import { ESTADOS_COBRO } from "api/Types/EstadosCobro"
import { ESTADOS_PAGO } from "api/Types/EstadosPago"

export const IS_PROD = JSON.parse(import.meta.env.REACT_APP_IS_PRODUCTION)

export const CURRENT_DATE_FORMAT = "DD/MM/YYYY"
export const CURRENT_DATE_FORMAT_WITH_HOURS = "DD/MM/YYYY hh:mm"
export const CURRENT_DATE_FORMAT_WITH_HOURS_LONG = "DD/MM/YYYY HH:mm:ss"

export const ESTADO_REVISION_DOCUMENTOS = {
  PENDIENTE: 1,
  VALIDADA: 2,
  RECHAZADA: 3,
  RECTIFICAR: 4,
}

export const ESTADO_PAGO_COBRO_FACTURA = {
  PENDIENTE: ESTADOS_COBRO.NO_COBRADO || ESTADOS_PAGO.NO_PAGADO,
  PARCIALMENTE:
    ESTADOS_COBRO.PARCIALMENTE_COBRADA || ESTADOS_PAGO.PARCIALMENTE_PAGADA,
  COMPLETADA: ESTADOS_COBRO.COBRADO || ESTADOS_PAGO.PAGADA,
}

export const TWENTY_MB = 20097152
export const ESTADO_REVISION_DOCUMENTO_OPTIONS = (t: $TSMigrationFixMe) => [
  {
    label: `${t("filtros.validateLabel")}`,
    value: ESTADO_REVISION_DOCUMENTOS.VALIDADA,
  },
  {
    label: `${t("filtros.rejectedLabel")}`,
    value: ESTADO_REVISION_DOCUMENTOS.RECHAZADA,
  },
]

export const ESTADO_REVISION_DOCUMENTO_FILTERS = (t: $TSMigrationFixMe) => [
  {
    label: `${t("filtros.allLabel")}`,
    value: "",
  },
  {
    label: `${t("filtros.pendingLabel")}`,
    value: ESTADO_REVISION_DOCUMENTOS.PENDIENTE,
  },
  {
    label: `${t("filtros.validateLabel")}`,
    value: ESTADO_REVISION_DOCUMENTOS.VALIDADA,
  },
  {
    label: `${t("filtros.rejectedLabel")}`,
    value: ESTADO_REVISION_DOCUMENTOS.RECHAZADA,
  },
]

export const ESTADO_REVISION_PROPERTIES = (t: $TSMigrationFixMe) => {
  return {
    [ESTADO_REVISION_DOCUMENTOS.PENDIENTE]: {
      backgroundColor: "#FFF6ED",
      color: "#FF7D00",
      text: t("crear.presupuesto.tab.pendingLabel"),
      description: t("crear.presupuesto.tab.pendingDescription"),
    },
    [ESTADO_REVISION_DOCUMENTOS.VALIDADA]: {
      backgroundColor: "#EDFCF5",
      color: "#00D770",
      text: t("crear.presupuesto.tab.validateLabel"),
      description: t("crear.presupuesto.tab.validateDescription"),
    },
    [ESTADO_REVISION_DOCUMENTOS.RECHAZADA]: {
      backgroundColor: "#FCEFF0",
      color: "#DB222A",
      text: t("crear.presupuesto.tab.rejectedLabel"),
      description: t("crear.presupuesto.tab.rejectedDescription"),
    },
  }
}

export const ESTADO_REVISION_FACTURAS_CESIONES = {
  CEDIDA_PENDIENTE: 0,
  CEDIDA_VERIFICADA: 1,
  CEDIDA_RECHAZADA: 2,
  CEDIDA_NO_CEDIDA: 3,
  CEDIDA_INACTIVE: null,
}

export const ESTADO_REVISION_CESIONES = {
  NULL: {
    backgroundColor: null,
    color: null,
    text: "-",
  },
  NO_CEDIDA: {
    backgroundColor: "#1A2543",
    color: "#1A2543",
    text: "No cedida",
  },
  CEDIDA_PENDIENTE: {
    backgroundColor: "#FF7D00",
    color: "#FF7D00",
    text: "Cedida pendiente",
  },
  CEDIDA_VERIFICADA: {
    backgroundColor: "#00D770",
    color: "#00D770",
    text: "Cedida verificada",
  },
  CEDIDA_RECHAZADA: {
    backgroundColor: "#DB222A",
    color: "#DB222A",
    text: "Cedida rechazada",
  },
}

export const getEstadoCesion = (
  estadoCesion: $TSMigrationFixMe,
  estadoVerificacion: $TSMigrationFixMe
) => {
  const isAcceptedStatus = [2, 3].includes(estadoCesion)

  switch (true) {
    case [1, 5].includes(estadoCesion):
      return ESTADO_REVISION_CESIONES.NO_CEDIDA
    case isAcceptedStatus && estadoVerificacion === 0:
      return ESTADO_REVISION_CESIONES.CEDIDA_PENDIENTE
    case isAcceptedStatus && estadoVerificacion === 1:
      return ESTADO_REVISION_CESIONES.CEDIDA_VERIFICADA
    case isAcceptedStatus && estadoVerificacion === 2:
      return ESTADO_REVISION_CESIONES.CEDIDA_RECHAZADA
    case isAcceptedStatus && estadoVerificacion === 3:
      return ESTADO_REVISION_CESIONES.NO_CEDIDA
    default:
      return ESTADO_REVISION_CESIONES.NULL
  }
}

export const estadoRevisionHasMotivo = (estadoRevision: $TSMigrationFixMe) =>
  estadoRevision === ESTADO_REVISION_DOCUMENTOS.RECTIFICAR ||
  estadoRevision === ESTADO_REVISION_DOCUMENTOS.RECHAZADA

export const ESTADO_REVISION_FACTURAS_RECURRENTES = {
  PENDIENTE: 1,
  OMITIDA: 2,
  CREADA: 3,
}
export const ESTADO_FACTURAS_RECURRENTES = {
  EN_CURSO: 1,
  FINALIZADA: 2,
}

export const ESTADO_REVISION_FACTURAS_RECURRENTES_PROPERTIES = (
  t: $TSMigrationFixMe
) => {
  return {
    [ESTADO_REVISION_FACTURAS_RECURRENTES.PENDIENTE]: {
      backgroundColor: "#FFF6ED",
      color: "#FF7D00",
      text: `${t("documentos.facturaRec.idView.modal.penddingLabel")}`,
      description: "Pendiente de revisión (estado por defecto).",
    },
    [ESTADO_REVISION_FACTURAS_RECURRENTES.OMITIDA]: {
      backgroundColor: "#FCEFF0",
      color: "#DB222A",
      text: `${t("documentos.facturaRec.idView.modal.omittedLabel")}`,
      description: "El receptor ha rechazado el documento.",
    },
    [ESTADO_REVISION_FACTURAS_RECURRENTES.CREADA]: {
      backgroundColor: "#EDFCF5",
      color: "#00D770",
      text: `${t("documentos.facturaRec.idView.modal.createdLabel")}`,
      description: "El documento está correctamente validado por el receptor.",
    },
  }
}

export const ESTADO_FACTURAS_RECURRENTES_PROPERTIES = (
  t: $TSMigrationFixMe
) => {
  return {
    [ESTADO_FACTURAS_RECURRENTES.EN_CURSO]: {
      backgroundColor: "#F0F4FF",
      color: "#2667FF",
      text: `${t("documentos.facturaRec.tab.inProgressLabel")}`,
    },
    [ESTADO_FACTURAS_RECURRENTES.FINALIZADA]: {
      backgroundColor: "#EDFCF5",
      color: "#00D770",
      text: `${t("documentos.facturaRec.tab.finalLabel")}`,
    },
  }
}

export const ESTADOS_PAGOS_COBROS = {
  NO_COBRADO_PAGADO: 0,
  COBRADO_PAGADO: 1,
  PARCIALMENTE_COBRADO_PAGADO: 2,
}

export const PAYMENT_TYPE = {
  COBRO: 1,
  PAGO: 2,
}

export const REMESA_TYPE = {
  SINRELACION: 0,
  FACTURA: 1,
  PRESTAMO: 2,
  DEVOLUCION: 3,
}

export const PAYMENT_TYPE_LABELS = (t: $TSMigrationFixMe) => {
  return {
    1: `${t("crear.factura.collectLabel")}`,
    2: `${t("crear.factura.payLabel")}`,
  }
}

export const ESTADO_REVISION_PAGOS = (t: $TSMigrationFixMe) => [
  {
    label: `${t("filtros.cartera.notPaidLabel")}`,
    value: ESTADOS_PAGOS_COBROS.NO_COBRADO_PAGADO,
  },
  {
    label: `${t("filtros.cartera.paidLabel")}`,
    value: ESTADOS_PAGOS_COBROS.COBRADO_PAGADO,
  },
  {
    label: `${t("filtros.cartera.partiallyPaidLabel")}`,
    value: ESTADOS_PAGOS_COBROS.PARCIALMENTE_COBRADO_PAGADO,
  },
]
export const ESTADO_REVISION_COBROS = (t: $TSMigrationFixMe) => [
  {
    label: `${t("filtros.cartera.notCollectedLabel")}`,
    value: ESTADOS_PAGOS_COBROS.NO_COBRADO_PAGADO,
  },
  {
    label: `${t("filtros.cartera.collectedLabel")}`,
    value: ESTADOS_PAGOS_COBROS.COBRADO_PAGADO,
  },
  {
    label: `${t("filtros.cartera.partiallyCollectedLabel")}`,
    value: ESTADOS_PAGOS_COBROS.PARCIALMENTE_COBRADO_PAGADO,
  },
]

export const ESTADO_REVISION_PAGOS_COBROS_FILTERS = (t: $TSMigrationFixMe) => {
  return {
    [PAYMENT_TYPE.COBRO]: ESTADO_REVISION_COBROS(t),
    [PAYMENT_TYPE.PAGO]: ESTADO_REVISION_PAGOS(t),
  }
}

export const ESTADO_REVISION_PAGOS_COBROS = (t: $TSMigrationFixMe) => {
  return {
    [PAYMENT_TYPE.PAGO]: {
      [ESTADOS_PAGOS_COBROS.NO_COBRADO_PAGADO]: {
        backgroundColor: "#FFF6ED",
        color: "#FF7D00",
        text: `${t("cartera.status.noCharged")}`,
        textModal: `${t("cartera.status.noChargedModal")}`,
        colorModal: "#FF7D00",
        value: 0,
      },
      [ESTADOS_PAGOS_COBROS.COBRADO_PAGADO]: {
        backgroundColor: "#EDFCF5",
        color: "#00D770",
        text: `${t("cartera.status.collected")}`,
        colorModal: "#00D770",
        value: 1,
      },
      [ESTADOS_PAGOS_COBROS.PARCIALMENTE_COBRADO_PAGADO]: {
        backgroundColor: "#EDFCF5",
        color: "#00D770",
        text: `${t("cartera.status.parcialyCollected")}`,
        textModal: `${t("cartera.status.parcialCollectedModal")}`,
        colorModal: "#FF7D00",
        value: 2,
      },
    },
    [PAYMENT_TYPE.COBRO]: {
      [ESTADOS_PAGOS_COBROS.NO_COBRADO_PAGADO]: {
        backgroundColor: "#FFF6ED",
        color: "#FF7D00",
        text: `${t("cartera.status.unpaid")}`,
        textModal: `${t("cartera.status.unpaidModal")}`,
        colorModal: "#FF7D00",
        value: 0,
      },
      [ESTADOS_PAGOS_COBROS.COBRADO_PAGADO]: {
        backgroundColor: "#EDFCF5",
        color: "#00D770",
        text: `${t("cartera.status.paid")}`,
        colorModal: "#00D770",
        value: 1,
      },
      [ESTADOS_PAGOS_COBROS.PARCIALMENTE_COBRADO_PAGADO]: {
        backgroundColor: "#EDFCF5",
        color: "#00D770",
        text: `${t("cartera.status.parcialPaid")}`,
        textModal: `${t("cartera.status.parcialPaidModal")}`,
        colorModal: "#FF7D00",
        value: 2,
      },
    },
  }
}

export const PRESTAMOS_STATUS = {
  PENDIENTE: 1,
  PROGRESO: 2,
  COMPLETADO: 3,
}

export const ESTADO_PRESTAMOS = (t: $TSMigrationFixMe) => {
  return {
    [PRESTAMOS_STATUS.PENDIENTE]: {
      twBackoundColor: "tw-bg-warning-10",
      twColor: "tw-text-alternative",
      backgroundColor: "#FFEFDD",
      color: "#FF961C",
      text: t ? `${t("prestamos.state.penddingLabel")}` : "prueba",
      textModal: t ? `${t("prestamos.state.modal.penddingLabel")}` : "prueba",
      colorModal: "#FF961C",
      value: 0,
    },
    [PRESTAMOS_STATUS.COMPLETADO]: {
      twBackoundColor: "tw-bg-secondary-10",
      twColor: "tw-text-secondary",
      backgroundColor: "#EAFBF5",
      color: "#30D59B",
      text: t ? `${t("prestamos.state.completLabel")}` : "pruebas",
      colorModal: "#30D59B",
      value: 1,
    },
    [PRESTAMOS_STATUS.PROGRESO]: {
      twBackoundColor: "tw-bg-[#ECF3FB]",
      twColor: "tw-text-[#0A66C2]",
      backgroundColor: "#ecf3fb",
      color: "#0a66c2",
      text: t ? `${t("prestamos.state.inProgressLabel")}` : "prueba",
      textModal: t ? `${t("prestamos.state.modal.penddingLabel")}` : "prueba",
      colorModal: "#FF961C",
      value: 2,
    },
  }
}

export const PRESTAMOS_TYPE = {
  CONCEDIDO: 1,
  RECIBIDO: 2,
}

export const ESTADO_TIPO_PRESTAMOS = (t: $TSMigrationFixMe) => {
  return {
    [PRESTAMOS_TYPE.CONCEDIDO]: {
      text: `${t("prestamos.grantedLabel")}`,
      value: PRESTAMOS_TYPE.CONCEDIDO,
      reversedValue: PRESTAMOS_TYPE.RECIBIDO,
      backgroundColor: "#d90368",
      color: "#ecf3fb",
    },
    [PRESTAMOS_TYPE.RECIBIDO]: {
      text: `${t("prestamos.receivedLabel")}`,
      value: PRESTAMOS_TYPE.RECIBIDO,
      reversedValue: PRESTAMOS_TYPE.CONCEDIDO,
      backgroundColor: "#d90368",
      color: "#ecf3fb",
    },
  }
}

export const COMISION_TYPE = {
  APERTURA: 1,
  ESTUDIO: 2,
  DISPOSICION: 3,
  CORRETAJE: 4,
  OTRA: 5,
  REEMBOLSO: 6,
}

export const ESTADO_TIPO_COMISION = (t: $TSMigrationFixMe) => {
  return {
    [COMISION_TYPE.APERTURA]: {
      text: `${t("comisiones.opening")}`,
      value: COMISION_TYPE.APERTURA,
      field: "comApertura",
      fullText: `${t("comisiones.openingFull")}`,
    },
    [COMISION_TYPE.ESTUDIO]: {
      text: `${t("comisiones.study")}`,
      value: COMISION_TYPE.ESTUDIO,
      field: "comEstudio",
      fullText: `${t("comisiones.studyFull")}`,
    },
    [COMISION_TYPE.DISPOSICION]: {
      text: `${t("comisiones.disposition")}`,
      value: COMISION_TYPE.DISPOSICION,
      field: "comDisposicion",
      fullText: `${t("comisiones.dispositionFull")}`,
    },
    [COMISION_TYPE.CORRETAJE]: {
      text: `${t("comisiones.brokerage")}`,
      value: COMISION_TYPE.CORRETAJE,
      field: "comCorretaje",
      fullText: `${t("comisiones.brokerageFull")}`,
    },
    [COMISION_TYPE.OTRA]: {
      text: `${t("comisiones.other")}`,
      value: COMISION_TYPE.OTRA,
      field: "comOtra",
      fullText: `${t("comisiones.otherFull")}`,
    },
    [COMISION_TYPE.REEMBOLSO]: {
      text: `${t("comisiones.reimbursement")}`,
      value: COMISION_TYPE.REEMBOLSO,
      field: "comReembolso",
      fullText: `${t("comisiones.reimbursementFull")}`,
    },
  }
}

export const COMISION_TYPE_ARRAY = [
  { field: "comApertura", value: 1 },
  { field: "comEstudio", value: 2 },
  { field: "comDisposicion", value: 3 },
  { field: "comCorretaje", value: 4 },
  { field: "comOtra", value: 5 },
  { field: "comReembolso", value: 6 },
]

export const CAMPOS_PERSONALISADOS_ENDPOINTS_SLICE = {
  prestamo: "Prestamo",
  contacto: "Contacto",
  artilculo: "Articulo",
}
